module.exports = __webpack_public_path__ + "static/media/facebook.63872238.svg";